import { Fragment, useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { PreOrderComponent } from "../Reports/PreOrder";
import { ConfirmationOrderComponent } from "../Reports/ConfirmationOrder";
import { WorkOrderComponent } from "../Reports/WorkOrder";
import { MapMechanicalComponent } from "../Reports/MechanicalWorkShopMap";
import App from "../App";
import { AuthContext } from "./AuthContext";
import { LoginUser } from "../Login/Login";
import { CalendarMechanical } from "../Reports/CalendarMechanical";
import {ManualComponent} from "../Reports/Manual/ManualsComponent";
import {PageWorkingComponent} from "./pageWorking";
import {ChatComponent} from "../Reports/Chat/Chat";

const ROUTERS = [
      {
            path: "/",
            element: <Navigate to="/Pre-Orden"/>
      },
      {
            path: "Pre-Orden",
            element: <PreOrderComponent/>
      },
      {
            path: "Confirmar-Orden",
            element: <ConfirmationOrderComponent/>
      },
      {
            path: "Orden-Trabajo",
            element:  <WorkOrderComponent/>
      },
      {
            path: "Talleres",
            element:  <MapMechanicalComponent/>
      },
      {
            path:"Calendario",
            element: <CalendarMechanical/>
      },
      {
            path: "Manual",
            element: <ManualComponent/>
      },
      {
            path: 'Diagrama',
            element: <PageWorkingComponent/>
      },
      {
            path: "Chat",
            element: <ChatComponent/>
      }
];

function PrivateRoutes({children}){

      const {logged} = useContext(AuthContext);

      return logged? children:<Navigate to="/app"/>
}

export function RoutersComponent(){
      return(
            <Fragment>
                  <Routes>
                        <Route path="/Login" element={<LoginUser/>} />
                        {
                              ROUTERS.map((router, index)=>(
                                    <Route key={`${router.path}-${index}`} path={router.path} element={
                                          <PrivateRoutes>
                                                {router.element}
                                          </PrivateRoutes>
                                    } />                                    
                              ))
                        }
                  </Routes>
            </Fragment>
      );
}